import { render, staticRenderFns } from "./JoinHeader.vue?vue&type=template&id=555cb00c&scoped=true&"
import script from "./JoinHeader.vue?vue&type=script&lang=js&"
export * from "./JoinHeader.vue?vue&type=script&lang=js&"
import style0 from "./JoinHeader.vue?vue&type=style&index=0&id=555cb00c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555cb00c",
  null
  
)

export default component.exports